export default function TestsPage() {
  // This component is no longer used since redirects are handled at the router level
  // Keeping it as a placeholder in case it's needed in the future
  return null;
}
